<template>
  <ul class="nav nav-tabs">
    <li
      :class="{
        active: isActiveTab('CustomerData') || isActiveTab('NewCustomer')
      }"
    >
      <router-link :to="{ name: 'CustomerData', params: { id: customerId } }">{{
        $label("customer.base_data_tab", "Data")
      }}</router-link>
    </li>

    <li
      :class="{
        active:
          isActiveTab('CustomerContacts') ||
          isActiveTab('CustomerContactDetails') ||
          isActiveTab('NewCustomerContact')
      }"
    >
      <router-link
        :to="{ name: 'CustomerContacts', params: { id: customerId } }"
        >{{ $label("customer.contacts_tab", "Contacts") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerBookings') }">
      <router-link
        :to="{ name: 'CustomerBookings', params: { id: customerId } }"
        >{{ $label("customer.bookings_tab", "Bookings") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerSharedBookings') }">
      <router-link
        :to="{ name: 'CustomerSharedBookings', params: { id: customerId } }"
        >{{
          $label("customer.sharedbookings_tab", "Shared Bookings")
        }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerCourses') }">
      <router-link
        :to="{ name: 'CustomerCourses', params: { id: customerId } }"
        >{{ $label("customer.courses_tab", "Courses") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerOutstandings') }">
      <router-link
        :to="{ name: 'CustomerOutstandings', params: { id: customerId } }"
        >{{ $label("customer.outstandings_tab", "Outstandings") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerInvoices') }">
      <router-link
        :to="{ name: 'CustomerInvoices', params: { id: customerId } }"
        >{{ $label("customer.invoices_tab", "Invoices") }}</router-link
      >
    </li>

    <li
      :class="{
        active:
          isActiveTab('CustomerParticipants') ||
          isActiveTab('NewCustomerParticipant') ||
          isActiveTab('CustomerParticipantDetails')
      }"
    >
      <router-link
        :to="{ name: 'CustomerParticipants', params: { id: customerId } }"
        >{{
          $label("customer.courseparticipants_tab", "Course Participants")
        }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerJournal') }">
      <router-link
        :to="{ name: 'CustomerJournal', params: { id: customerId } }"
        >{{ $label("customer.journal_tab", "Journal") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerDocuments') }">
      <router-link
        :to="{ name: 'CustomerDocuments', params: { id: customerId } }"
        >{{ $label("customer.documents_tab", "Documents") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerBalance') }">
      <router-link
        :to="{ name: 'CustomerBalance', params: { id: customerId } }"
        >{{ $label("customer.balance_tab", "Balance") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerMember') }">
      <router-link
        :to="{ name: 'CustomerMember', params: { id: customerId } }"
        >{{ $label("customer.member_tab", "Member") }}</router-link
      >
    </li>

    <li :class="{ active: isActiveTab('CustomerGroupBookings') }">
      <router-link
        :to="{ name: 'CustomerGroupBookings', params: { id: customerId } }"
        >{{
          $label("customer.groupbookings_tab", "Group Bookings")
        }}</router-link
      >
    </li>
  </ul>
</template>

<script>
export default {
  props: ["customerId"],

  methods: {
    isActiveTab(tab) {
      return this.$route.name == tab;
    }
  }
};
</script>
